export default {"src":"/_next/static/media/ticket.21d20005.svg","height":269,"width":786,"blurWidth":0,"blurHeight":0};